import styled from 'styled-components';

import { media } from 'utils/detection';

import CaseStudyReference from 'components/CaseStudyReference';

export default styled(CaseStudyReference)`
  position: relative;
  padding: 0 40px;
  margin: 73px 0 80px 0;

  ${media.medium`
    margin: 10vw 0 14vw 40%;
  `}
`;
